export default "__VITE_ASSET__BwBO9TLx__"